import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imUploader', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/uploader/uploader.html'),
        controller: 'UploaderController',
        controllerAs: 'UploaderCtrl',
        bindings: {
            anexes: '<', // boolean
            fileList: '=',
            documentsBackend: '<',
            maxFiles: '<',
            maxSize: '<',
            isImage: '<',
            isUploaded: '=',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/uploader/uploader.component.ts